import { z } from 'zod';

export type INameModel = typeof NameModel;
export type INameModelSnapshot = z.input<INameModel>;

export const NameModel = z.object({
  firstName: z.string(),
  lastName: z.string(),
});
